import Press from './press.js';

export default Press;
